// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"794":"record-detail","893":"record-list"}[chunkId] + "." + {"794":"c502c801","893":"1cb6c090"}[chunkId] + ".js";
};